export default {
  state: {
    categories: [],
    tk_it:[],
    tkcategories:[],
    comId:'1001'
  },
  getters: {},
  mutations: {
    setCategories(state, val) {
      state.categories = val.data;
      state.comId = val.comid;
    },
    setTK_it(state,val){
      state.tk_it = val;
    },
    setTKCategories(state, val) {
      state.tkcategories = val;
    },
  },
  actions: {
    async getCategories({ commit, state },id) {
      return new Promise(resolve => {
        if (state.categories && state.categories.length > 0 && state.comId == id) {
          resolve(state.categories);
        } else {
          this.$axios.get("/app/api/jobcategory/listByProductId?productId="+id).then(res => {
            const obj = {data:res.data,comid:id}
            commit("setCategories", obj);
            resolve(res.data);
          });
        }
      });
    },
    async getTk_it({ commit, state }) {
      return new Promise(resolve => {
        if (state.tk_it && state.tk_it.length > 0) {
          resolve(state.tk_it);
        } else {
          this.$axios.get("/json/tk_it.json").then(list => {
            commit("setTK_it", list);
            resolve(list);
          });
        }
      });
    },
    async getTKCategories({ commit, state }) {
      return new Promise(resolve => {
        if (state.tkcategories && state.tkcategories.length > 0) {
          resolve(state.tkcategories);
        } else {
          this.$axios.get("https://qihuibao.oss-cn-beijing.aliyuncs.com/public/json/taikangzhiye.json").then(res => {
            commit("setTKCategories", res);
            resolve(res);
          });
        }
      });
    },
  }
};
